// routing
import PurchaseProjectRouting from './purchase-project/purchase-project-routing';
import SignUpPurchaseRouting from './sign-up-purchase/sign-up-purchase-routing';
import SignUpRecordRouting from './sign-up-record/sign-up-record-routing';
import PurchaseFileDownloadRouting from './purchase-file-download/purchase-file-download-routing';
import ContractingProjectRouter from './contracting-project/contracting-project-routing';
import BidPurchaseProject from './bid-purchase-project/bid-purchase-routing';

// component
import RouterView from '@/components/router-view.vue';

export default [
  {
    path: 'purchase-project',
    component: RouterView,
    redirect: '/person-center/purchase-business/purchase-project/list',
    meta: {
      title: '我的采购项目'
    },
    children: PurchaseProjectRouting
  },
  {
    path: 'sign-up-record',
    component: RouterView,
    redirect: '/person-center/purchase-business/sign-up-record/list',
    meta: {
      title: '报名审核记录'
    },
    children: SignUpRecordRouting
  },
  {
    path: 'sign-up-purchase',
    component: RouterView,
    redirect: '/person-center/purchase-business/sign-up-purchase/list',
    meta: {
      title: '报名采购标的'
    },
    children: SignUpPurchaseRouting
  },
  {
    path: 'purchase-file-download',
    component: RouterView,
    redirect: '/person-center/purchase-business/purchase-file-download/list',
    meta: {
      title: '采购文件下载'
    },
    children: PurchaseFileDownloadRouting
  },
  {
    path: 'contracting-project',
    component: RouterView,
    redirect: '/person-center/purchase-business/contracting-project/list',
    meta: {
      title: '成交采购项目'
    },
    children: ContractingProjectRouter
  },
  {
    path: 'bid-purchase-project',
    component: RouterView,
    redirect: '/person-center/purchase-business/bid-purchase-project/list',
    meta: {
      title: '竞价采购标的'
    },
    children: BidPurchaseProject
  }
];

